import { createFileRoute } from "@tanstack/react-router";

import { logout } from "~/stores/auth";

export const Route = createFileRoute("/logout")({
  loader: async () => {
    await logout();
  },
});
